
import type { StoreInfo } from '../api/delivery';

export interface Branding {
  primaryColor: string;
  accentColor: string;
  logoUrl: string | null;
  bannerUrl: string | null;
  description: string | null;
  addressLine: string | null;
  whatsappNumber: string | null;
  storeHours: string | null;
  deliveryTimeMin: number | null;
  deliveryTimeMax: number | null;
  deliveryFeeText: string | null;
  minimumOrderCents: number | null;
}

export function getBranding(store: StoreInfo): Branding {
  const b = (store.modules as Record<string, unknown>)?.deliveryBranding as Record<string, unknown> | undefined;
  return {
    primaryColor:      (b?.primaryColor      as string)  ?? '#2D6A2D',
    accentColor:       (b?.accentColor       as string)  ?? '#8B6914',
    logoUrl:           (b?.logoUrl           as string)  ?? null,
    bannerUrl:         (b?.bannerUrl         as string)  ?? null,
    description:       (b?.description       as string)  ?? null,
    addressLine:       (b?.addressLine       as string)  ?? null,
    whatsappNumber:    (b?.whatsappNumber    as string)  ?? null,
    storeHours:        (b?.storeHours        as string)  ?? null,
    deliveryTimeMin:   (b?.deliveryTimeMin   as number)  ?? null,
    deliveryTimeMax:   (b?.deliveryTimeMax   as number)  ?? null,
    deliveryFeeText:   (b?.deliveryFeeText   as string)  ?? null,
    minimumOrderCents: (b?.minimumOrderCents as number)  ?? null,
  };
}

export const fmt = (cents: number) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
